import styled from 'styled-components';

import variables from '../../../styles/variables';
import Image from '../../UI/Image/Image';

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  width: 100%;
  position: relative;
  margin: 40px auto;
`;

export const Header = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto 24px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: ${variables.defaultWidth}px;
  padding: 0 ${variables.layoutPadding}rem;

  @media screen and (max-width: 1023px) {
    max-width: ${variables.defaultWidth}px;
    padding: 0 ${variables.mobileLayoutPadding}rem;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    gap: 8px;
  }

  @media screen and (max-width: 600px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
  }

  a {
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    text-decoration-line: underline;
    margin-bottom: 0;
    @media screen and (max-width: 767px) {
      font-size: 14px;
      line-height: 14px;
    }
  }
`;

export const Headline = styled.h2`
  color: ${variables.colorBlack};
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  margin-bottom: 0 !important;

  @media screen and (max-width: 767px) {
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 2rem;
  max-width: ${variables.defaultWidth}px;
  padding: 0 ${variables.layoutPadding}rem;

  @media screen and (max-width: 1023px) {
    max-width: ${variables.defaultWidth}px;
    padding: 0 ${variables.mobileLayoutPadding}rem;
    gap: 1rem;
  }

  @media screen and (max-width: 767px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }

  @media screen and (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  // Grid fix for Safari
  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) and (display: flow-root) {
      grid-template-rows: max-content;
    }
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  max-width: 100%;
  width: 100%;
  padding: 1rem;
  border-radius: 20px;
`;

export const Icon = styled(Image)`
  height: 45px;
  margin-bottom: 16px;
`;

export const Title = styled.p`
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: ${variables.colorRed3};
  text-align: center;
  margin-bottom: 0;

  @media screen and (max-width: 767px) {
    font-size: 16px;
  }
`;

export const Description = styled.p`
  font-size: 18px;
  font-weight: normal;
  line-height: 28px;
  color: ${variables.colorBlack};
  text-align: center;
  margin-bottom: 0;

  @media screen and (max-width: 767px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const CtaContainer = styled.div`
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: flex-start;

  .text-link {
    font-weight: 600;
  }
`;
